import React, { useContext, useMemo, useState } from "react";
import { useRouteMatch, Link } from "react-router-dom";
import { Button, Tabs } from "@pushpress/shared-components";
import BackArrow from "../../../assets/img/icons/icon-arrow-east.svg";
import AppointmentTypeList from "../AppointmentTypeList";
import AppointmentDiscountList from "../AppointmentDiscountList";
import AppointmentPackageList from "../AppointmentPackageList";
import AppointmentPayRateList from "../AppointmentPayRateList";
import styles from "./AppointmentSettings.module.scss";
import { AppContext } from "../../../context/app";

function AppointmentSettings() {
  const { path } = useRouteMatch("/appointments");

  const { user } = useContext(AppContext);

  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const tabHeaders = useMemo(() => {
    const tabs = ["Types", "Packages", "Discounts"];
    if (user?.role === "admin" || user?.superuser) {
      tabs.push("Pay rates");
    }
    return tabs;
  }, [user]);

  const onTabClick = (index) => {
    setSelectedTabIndex(index);
  };

  const moveTabs = () => {
    const index = selectedTabIndex === 2 ? 0 : selectedTabIndex + 1;
    setSelectedTabIndex(index);
  };

  const url = `${path}`;

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <Button
          component={Link}
          text="Back to Appointments"
          buttonType="text"
          to={url}
          icon={BackArrow}
          iconLocation="left"
        />
      </div>
      <div className={styles.content}>
        <Tabs
          tabHeaders={tabHeaders}
          selectedIndex={selectedTabIndex}
          changeTab={moveTabs}
          onTabClick={onTabClick}
        >
          <AppointmentTypeList />
          <AppointmentPackageList />
          <AppointmentDiscountList />
          <AppointmentPayRateList />
        </Tabs>
      </div>
    </div>
  );
}

export default AppointmentSettings;
